import ParsedDecoratorChildren from "../components/ParsedDecoratorChildren";
import { REGEX_UNDERLINE } from "../regex";
import { jsx as _jsx } from "react/jsx-runtime";
var Underline = function Underline(_ref) {
  var offsetKey = _ref.offsetKey,
    decoratedText = _ref.decoratedText,
    isDark = _ref.isDark;
  var text = decoratedText.match(REGEX_UNDERLINE) ? decoratedText.substring(2, decoratedText.length - 2) : decoratedText;
  return /*#__PURE__*/_jsx("span", {
    className: "underline",
    "data-offset-key": offsetKey,
    children: /*#__PURE__*/_jsx(ParsedDecoratorChildren, {
      text: text,
      isDark: isDark
    })
  });
};
export default Underline;